// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface OrganizationBankAccountDTO
 */
export interface OrganizationBankAccountDTO {
    /**
     * 
     * @type {string}
     * @memberof OrganizationBankAccountDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBankAccountDTO
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBankAccountDTO
     */
    accountType: OrganizationBankAccountDTOAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBankAccountDTO
     */
    accountName: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBankAccountDTO
     */
    bankName: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBankAccountDTO
     */
    sortCode: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBankAccountDTO
     */
    accountNumber: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBankAccountDTO
     */
    verificationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBankAccountDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBankAccountDTO
     */
    deletedAt?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum OrganizationBankAccountDTOAccountTypeEnum {
    DEFAULT = 'DEFAULT',
    CLAIM = 'CLAIM',
    CASHDEPOSITSCHEME = 'CASH_DEPOSIT_SCHEME'
}



